module.exports = __webpack_public_path__ + "static/media/wa-background-black.cb32dcb2.png";